import React, {  useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import AddHeader from '../components/AddHeader/AddHeader';
import FormContainer from '../components/FormContainer/FormContainer';
import { useNavigate } from 'react-router-dom';
import { addCategory, fetchCategories } from '../hooks/categories';

function AddCategory() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [ar_categoryName, setar_categoryName] = useState('')
  const [en_categoryName, seten_categoryName] = useState('')
    const [image, setImage] = useState(null);
const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false)
    const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  setImage(file);
  setImagePreview(URL.createObjectURL(file));
};

  const inputs = [
    { id: 0, name: currentLocal.home.namePlaceholder+" "+currentLocal.home.inEN, value: en_categoryName, onChanegFunction: (e) => seten_categoryName(e.target.value), grid: 6 },
    { id: 1, name:  currentLocal.home.namePlaceholder+" "+currentLocal.home.inAR, value: ar_categoryName, onChanegFunction: (e) => setar_categoryName(e.target.value), grid: 6 },
    { id: 3, name: currentLocal.home.image, onChanegFunction: handleImageChange, grid: 6 ,type: "file"},

  ]
  const handleSubmit = () => {
                  const formData = new FormData();
                  formData.append('name_ar', ar_categoryName)
                  formData.append('name_en', en_categoryName)
                  formData.append('description', "description")
  if (image) {
    formData.append("image", image);
  }

    setLoading(true)

    dispatch(addCategory(formData))
      .unwrap()
      .then(() => {
        setLoading(false)
        dispatch(fetchCategories())
        alert(currentLocal.home.addedsuccessfully)
        navigate("/dashboard/categories")

      })
      .catch((err) => {
        setLoading(false)

      });
  }
  return (
    <div className='outlit_bg'>
      <AddHeader
        title={currentLocal.home.addcategory}
      />
      <div className='body_container mx-4'  >
        <p className='border-bottom pb-3'>{currentLocal.home.addcategory}</p>
        <FormContainer
          inputs={inputs}
          btnText={currentLocal.home.add}
          handleSubmit={handleSubmit}
          loading={loading}
          imagePreview={imagePreview}
        />
      </div>
    </div>
  )
}

export default AddCategory


